import React, { useState, useRef } from 'react';
import { useApp } from "../context/AppContext";

import '../styles/Website.css';

import { ReactComponent as AssetIconWebsite } from '../resources/assets/iconWebsite.svg'; 

const Website = ({ url }) => {
    const { appSendMessage } = useApp();
    const iconRef = useRef(null);

    return (
        <div className='website-panel'>
            <div className='website-text'>{url}</div>
            <div ref={iconRef} className='website-open' onClick={() => appSendMessage("openURL", url)}>
                <div className='address-navigate-icon'>
                    <AssetIconWebsite />
                </div>
            </div>
        </div>
    );
};

export default Website;